import jwtDecode from "jwt-decode";
import { DecodedAuthToken } from "../types/auth";

export const isTokenValid = (token: string): boolean => {
    const decodedToken = jwtDecode<DecodedAuthToken>(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp > currentTime;
}

export const getUserIdFromToken = (token: string): string | null => {
    try {
        const decodedToken = jwtDecode<DecodedAuthToken>(token);
        return decodedToken.nameid || null;
    } catch {
        return null;
    }
}